<template>
	<div class='c-autocomplete'>
		<c-input v-model='inpVal'
			:label='label'
			@input='onInput'
			@focus='focusHandle'
			@blur='blurHandle'
			:autocomplete='autocomplete'
			:error='error'
		/>
		<div class='select a-select' v-if='isOpen'>
			<transition>
				<div class='options'>
					<div class='option'
						:key='index'
						v-for='(item, index) in options'
						@click='setValue(item)'
					>{{ item.label }}
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>
<script>
import input from '__jsVueUI/c-input/c-input.vue';
import changeHandleTimeout from '__jsVueMixin/changeHandleTimeout';

export default {
	name:   'c-autocomplete',
	mixins: [changeHandleTimeout],
	props:      [
		'value', 'label', 'options', 'autocomplete', 'error'
	],
	components: {
		'c-input':    input,

	},
	created() {
		this.inpVal = this.model.label;
	},
	data() {
		return {
			isOpen: false,
			inpVal: ''
		};
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(newVal) {
				this.$emit('input', newVal);
			}
		}
	},
	methods: {
		focusHandle() {
			this.onInput();
		},
		blurHandle() {
			setTimeout(() => {
				this.isOpen = false;
			}, 300);
		},
		setValue(item) {
			this.model = item;
			this.isOpen = false;
		},
		updateOptionsHandle() {
			this.isOpen = true;
		},
		onInput() {
			if (!this.inpVal) {
				this.model = {
					label: '',
					value: ''
				};
			}
			this.changeHandleTimeoutHandle(500, async() => {
				this.$emit('filter', this.inpVal, this.updateOptionsHandle);
			});
		},
	},
	watch: {
		model() {
			setTimeout(() => {
				this.inpVal = this.model.label;
			}, 0);
		}
	}
};
</script>
